/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// Centralisation des routes API
const API_ROUTES = {
  PLACE_ORDER: "/api/order/place_order",
  GET_ORDERS: "/api/order/get_order",
  GET_ORDER_BY_ID: "/api/order/get_order_by_id",
  UPDATE_Order_PRODUCT_QUANTITY: "api/order/update_order/",
  DELETE_ORDER_PRODUCT: "/api/order/delete_order/",
};
// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) =>
  error.response?.data.message || error.message;

export const place_order = createAsyncThunk(
  "order/place_order",
  async (
    {
      products,
      price,
      Shipping_fees,
      items,
      shippingInfo,
      customerId,
      mode,
      navigate,
    },
    { rejectWithValue, fulfillWithValue },
  ) => {
    try {
      const { data } = await api.post(
        API_ROUTES.PLACE_ORDER,
        {
          products,
          price,
          Shipping_fees,
          items,
          shippingInfo,
          customerId,
          mode,
          navigate,
        },
        { withCredentials: true },
      );
      //console.log("API Response order:", data); // Log the API response

      navigate("/payment", {
        state: {
          price: price + Shipping_fees,
          items,
          orderId: data.orderId,
        },
      });
      return true;

      // return fulfillWithValue(data);
    } catch (error) {
      // console.error("Error adding to card", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const get_orders = createAsyncThunk(
  "order/get_orders",
  async (
    { customerId, status, pageNumber },
    { rejectWithValue, fulfillWithValue },
  ) => {
    // console.log('customerId :>> ', customerId);

    try {
      const { data } = await api.get(
        `${API_ROUTES.GET_ORDERS}/${customerId}/${status}?&&pageNumber=${pageNumber}`,
        { withCredentials: true },
      );
      // console.log('api response getting orders', data);
      return fulfillWithValue(data);
    } catch (error) {
      //console.log('error geting orders', error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const get_order = createAsyncThunk(
  "order/get_order",
  async ({ orderId }, { rejectWithValue, fulfillWithValue }) => {
    // console.log('order id from get order', orderId);
    try {
      const { data } = await api.get(
        `${API_ROUTES.GET_ORDER_BY_ID}/${orderId}`,
        { withCredentials: true },
      );
      // console.log('api response getting order', data);
      return fulfillWithValue(data);
    } catch (error) {
      console.log("error geting order", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const updateOrderProductQuantity = createAsyncThunk(
  "order/updateOrderProductQuantity",
  async (
    { orderId, sellerId, cardId, state, newQuantity },
    { dispatch, rejectWithValue, getState, fulfillWithValue },
  ) => {
    try {
      const { data } = await api.put(
        API_ROUTES.UPDATE_Order_PRODUCT_QUANTITY +
          `${orderId}/${sellerId}/${cardId}`,
        { state, newQuantity },
        {
          withCredentials: true,
        },
      );
      // 🔥 On recharge directement le panier APRES update quantité
      const customerId = getState().order.MyOrder.customerId;
      //console.log('customer id ', customerId)
      if (customerId) {
        dispatch(get_order({ orderId }));
      }
      //  console.log('api response update product quantity', data)
      return fulfillWithValue(data);
    } catch (error) {
      // console.log(' error update product quantity', error)
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const delete_order_product = createAsyncThunk(
  "order/delete_order_product",
  async (
    { orderId, cardId, sellerId },
    { rejectWithValue, fulfillWithValue },
  ) => {
    try {
      const { data } = await api.delete(
        API_ROUTES.DELETE_ORDER_PRODUCT + `${orderId}/${sellerId}/${cardId}`,

        { withCredentials: true },
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Reducer principal
export const orderReducer = createSlice({
  name: "order",
  initialState: {
    successMessage: "",
    messageError: "",
    OrderInfo: {},
    MyOrder: {},
    myOrders: [],
    loading: false,
    parPage: 5,
    totalOrder: 0,
  },
  reducers: {
    setOrderInfo: (state, action) => {
      state.OrderInfo = action.payload;
    },
    messageClear: (state) => {
      state.messageError = "";
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(place_order.pending, (state) => {
        state.loading = true;
        state.messageError = "";
      })
      .addCase(place_order.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
      })
      .addCase(place_order.rejected, (state, action) => {
        state.loading = false;
        state.messageError = action.payload.message;
      })
      .addCase(get_orders.pending, (state) => {
        state.loading = true;
        state.messageError = "";
      })
      .addCase(get_orders.fulfilled, (state, action) => {
        state.loading = false;
        state.myOrders = action.payload.paginatedOrders;
        state.successMessage = action.payload.message;
        state.totalOrder = action.payload.totalOrder;
      })
      .addCase(get_orders.rejected, (state, action) => {
        state.loading = false;
        state.messageError = action.payload.message;
      })
      .addCase(get_order.pending, (state) => {
        state.loading = true;
        state.messageError = "";
      })
      .addCase(get_order.fulfilled, (state, action) => {
        state.loading = false;
        state.MyOrder = action.payload.finalOrder;
        state.successMessage = action.payload.message;
      })
      .addCase(get_order.rejected, (state, action) => {
        state.loading = false;
        state.messageError = action.payload.message;
      })

      .addCase(delete_order_product.pending, (state) => {
        state.loading = true;
        state.messageError = "";
      })
      .addCase(delete_order_product.rejected, (state, action) => {
        state.loading = false;
        state.messageError =
          action.payload?.message || "Erreur lors de la suppression.";
      })

      .addCase(delete_order_product.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage =
          action.payload?.message || "Produit supprimé de la commande.";

        if (action.payload.orderDeleted) {
          state.MyOrder = null; // Toute la commande a été supprimée
        } else if (state.MyOrder?.products) {
          const { cardId } = action.payload;

          state.MyOrder.products = state.MyOrder.products.filter((product) => {
            return product.cardId !== cardId;
          });

          // Mettre à jour le prix total de la commande côté client
          if (typeof action.payload.updatedCustomerOrderPrice === "number") {
            state.MyOrder.price = action.payload.updatedCustomerOrderPrice;
          }
        }
      });
  },
});

export const { setOrderInfo, messageClear } = orderReducer.actions;
export default orderReducer.reducer;
